'use client'

import React from 'react'
import type { RenderedService } from '@/types/interfaces/service-item'
import Shelf, { type ShelfData } from './Shelf'
import classes from './ShelfGroup.module.css'

export interface ShelfGroupProps {
    shelfGroup: RenderedService
}

/**
 * Group of product shelves. Each shelf owns its own motion unit.
 */
export default function ShelfGroup({ shelfGroup }: ShelfGroupProps) {
    const shelves = ((shelfGroup as { shelves?: ShelfData[] }).shelves ?? []).filter(
        (shelf) => (shelf.services?.length ?? 0) > 0,
    )

    if (shelves.length === 0) return null

    return (
        <section className={classes.root} data-shelf-group={shelfGroup.id}>
            {shelves.map((shelf, index) => (
                <Shelf key={shelf.id ?? `shelf-${index}`} shelf={shelf} />
            ))}
        </section>
    )
}

export { default as Shelf } from './Shelf'
export { default as Product } from './Product'
export { default as ProductImage } from './ProductImage'
export type { ShelfData, ShelfProps } from './Shelf'
export type { ProductProps } from './Product'
